import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Veiculo } from '../interfaces/veiculo';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { VeiculoEnums } from '../interfaces/veiculo-enums';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class VeiculoService {
  
  
  readonly path = '/veiculo';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  create(): Observable<Veiculo> {
    return this.http.post<Veiculo>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  getVeiculo(id: number): Observable<Veiculo> {
    return this.http.get<Veiculo>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  saveOrUpdate(cadastro: Veiculo): Observable<Veiculo> {
    return this.http.put<Veiculo>(`${this.jwtAuthService.apiUrl + this.path}`, cadastro);
  }

  getEnums(): Observable<VeiculoEnums> {
    return this.http.get<VeiculoEnums>(`${this.jwtAuthService.apiUrl + this.path}/enums`);
  }

  getVeiculoPage(page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<Veiculo>> {
    const params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC');
    return this.http.get<PageResult<Veiculo>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/`, { params });
  }

  getVeiculoPageSearch(page?: number, size?: number,  search?: string, order?: string,
    direction?: string): Observable<PageResult<Veiculo>> {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC');
    if (search) {
      params = params.set('search', search);
    }
    return this.http.get<PageResult<Veiculo>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/`, { params });
  }

  deleteVeiculo(id: any) {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }


}
